<template>
  <div>
    <va-toggle
      :label="deleting?$t('users.removeAccept') : $t('users.removeReject')"
      v-model="deleting"
    />
    <message-area :label="deleting?$t('users.removeAcceptMessage'):$t('users.removeRejectMessage')" v-model="message" />
    <va-button v-if="cancel === true" color="gray" @click="hendlerCancel">Cancel</va-button>
    <va-button @click="submitForm" :color="deleting?'danger':'primary'" :disabled="!(message)">{{deleting?$t('users.removeAccept') : $t('users.removeReject')}}</va-button>
  </div>
</template>
<script>
import MessageArea from '../../notification/components/MessageArea.vue'

export default {
  data() {
    return {
      deleting: '',
      message: '',
    }
  },
  props: {
    userId: { type: Number, required: true },
    cancel: { type: Boolean, default: false },
  },
  methods: {
    clearFields() {
      this.deleting = ''
      this.message = ''
    },
    hendlerCancel() {
      this.$emit('cancel')
    },
    submitForm() {
      this.$emit('submit', { data: { user_id: this.userId, deleting: this.deleting, message: this.message }, clear: this.clearFields })
    },
  },
  components: { MessageArea },
}
</script>
